export default "__VITE_ASSET__CcvZbedu__"